<template>
  <span class="help-icon">
    <i :id="uniqueId" class="fa fa-question-circle mr-1" aria-hidden="true"></i>
    <help-tooltip :target="uniqueId" v-bind="$attrs">
      <slot></slot>
    </help-tooltip>
  </span>
</template>

<script>
  import HelpTooltip from './HelpTooltip';

  export default {
    name: 'Help',

    components: {
      HelpTooltip,
    },

    computed: {
      uniqueId() {
        return `help-${this._uid}`;
      },
    },
  };
</script>
